const searchList = {
  All: ['时间', '中国省份', '行业', '机构', '关键词'],
  // All: ['时间', '国家', '中国省份', '行业', '机构', '关键词'],
  'Real-time Info': ['二级栏目', '时间', '中国省份', '行业', '机构', '关键词'],
  // 'Real-time Info': ['二级栏目', '时间', '国家', '中国省份', '行业', '机构', '关键词'],
  inquiry: ['二级栏目', '时间', '国家', '机构', '关键词'],
  case: ['二级栏目', '时间', '国家', '机构', '关键词'],
  Report: ['时间', '中国省份', '行业', '机构', '关键词'],
  // Report: ['时间', '国家', '中国省份', '行业', '机构', '关键词'],
  Video: ['时间', '中国省份', '行业', '机构', '关键词']
  // Video: ['时间', '国家', '中国省份', '行业', '机构', '关键词']
}
const chinaToEnglish = {
  '国家': 'Country & Region',
  '人物': 'Figure',
  '关键词': 'Keyword',
  '机构': 'Organization',
  '时间': 'Time',
  '二级栏目': 'Column',
  '案例类型': 'Case',
  '咨询类型': 'consultation',
  '研报类型': 'Research Reports',
  '行业': 'Industry',
  '中国省份': 'China Provincial-level region'
}
const typeAgg = [
  {
    key: 'Real-time Info',
    id: 'Real-time Info',
    // id: '102',
    value: 'Real-time Info'
  },
  {
    key: 'Report',
    id: 'All',
    // id: '99',
    value: 'Report',
    filter: {'k': 'type.keyword', 'v': ['magazine'], 'd': '0'},
    option: {
      'featureWeights': [
        {'k': '16', 'v': '2'},
        {'k': '19', 'v': '1'},
        {'k': '18', 'v': '1.3'},
        {'k': '17', 'v': '1.5'},
        {'k': '20', 'v': '2'}
      ]
    }
  },
  {
    key: 'Video',
    id: 'All',
    // id: '99',
    value: 'Video',
    filter: {'k': 'type', 'v': ['video'], 'd': '0'},
    option: {
      'featureWeights': [{'k': '16', 'v': '2'}, {'k': '19', 'v': '1'}, {'k': '18', 'v': '1.3'}, {
        'k': '17',
        'v': '1.5'
      }, {'k': '20', 'v': '2'}]
    }
  },
  {
    key: 'case',
    id: '案例',
    // id: 'lead963',
    value: '案例'
  },
  {
    key: 'inquiry',
    id: '观点',
    // id: 'lead962',
    value: '观点'
  },
  {
    key: 'video',
    id: '视频',
    // id: 'lead962',
    value: '视频'
  },
  {
    key: 'information',
    id: '动态',
    // id: 'lead961',
    value: '动态'
  }
]
const searchAggs = [ // 筛选
  {
    d: '0',
    v: [
      {
        key: '1',
        value: '智讯参考'
      },
      {
        key: '2',
        value: '丝路情报'
      },
      {
        key: '3',
        value: '公共安全风险报告'
      },
      {
        key: '4',
        value: '投资风险报告'
      },
      {
        key: '5',
        value: '投资风险周报'
      }
    ],
    k: {
      type: 'terms',
      columnItem: 'type',
      name: '研报类型'
    }
  },
  {
    d: '0',
    v: [],
    k: {
      types: 'terms',
      columnItem: 'catName.keyword',
      name: '二级栏目'
    }
  },
  {
    d: '3',
    v: [],
    k: {
      'types': 'terms',
      'columnItem': 'published',
      'name': '时间',
      'interval': 'year',
      'format': 'yyyy'
    }
  },
  {
    d: '0',
    v: [],
    k: {
      types: 'terms',
      columnItem: 'one_level_state.keyword',
      name: '国家'
    }
  },
  {
    d: '0',
    v: [],
    k: {
      types: 'terms',
      columnItem: 'one_level_person.keyword',
      name: '人物'
    }
  },
  {
    d: '0',
    v: [],
    k: {
      types: 'terms',
      columnItem: 'one_level_org.keyword',
      name: '机构'
    }
  },
  {
    d: '0',
    v: [],
    k: {
      types: 'terms',
      columnItem: 'source.keyword',
      name: '来源'
    }
  },
  {
    d: '0',
    v: [],
    k: {
      types: 'terms',
      columnItem: 'author.keyword',
      name: '作者'
    }
  },
  {
    d: '0',
    v: [],
    k: {
      types: 'terms',
      columnItem: 'key_words.keyword',
      name: '关键词',
      include: '(.){3,10}', // 新增的
      exclude: '中文摘要|原文标题' // 新增的
    }
  },
  {
    'd': '0',
    'v': [],
    'k': {
      'types': 'terms',
      'columnItem': 'one_level_province.keyword',
      'name': '中国省份'
    }
  },
  {
    'd': '0',
    'v': [],
    'k': {
      'types': 'terms', 'columnItem': 'industry.keyword',
      'name': '行业'
    }
  }
]
const allSearchType = ['All']
export default {
  searchList,
  searchAggs,
  allSearchType,
  typeAgg,
  chinaToEnglish
}
